import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Home from '../src/pages/Home';
import Login from './Auth/Login';
import Signup from './Auth/Signup';
import ForgetPassword from "./Auth/SendLink"
import Confirmpassword from './Auth/Confirmpassword';
import Verification from './Auth/Verification';
import Blogs from './pages/Blog';
import Articles from './pages/Article';
import HowitsWork from './pages/Howwork';
import Pricing from './pages/Price';
import Review from './pages/ImageRev';
import Faq from "./pages/Faq";
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />}/>
          <Route exact path="/Login" element={<Login />}/>
          <Route exact path="/Signup" element={<Signup />}/>
          <Route exact path="/Forgetpassword" element={<ForgetPassword />}/>
          <Route exact path="/Confirmpassword" element={<Confirmpassword />}/>
          <Route exact path="/Verification" element={<Verification />}/>
          <Route exact path="/Blogs" element={<Blogs />}/>
          <Route exact path="/Articles" element={<Articles />}/>
          <Route exact path="/HowitsWork" element={<HowitsWork />}/>
          <Route exact path="/Pricing" element={<Pricing />}/>
          <Route exact path="/Review" element={<Review />}/>
          <Route exact path="/Faq" element={<Faq />}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
